export const useLeftNavStore = defineStore('leftNav', () => {
  const isRailOpen = ref(false)
  const nav = ref([
    //{ to: '/', label: 'HOME', icon: 'mdi-home' },
    /*
    {
      to: '/inventory',
      label: 'INVENTORY',
      icon: '',
      groups: ['WEB_SHOW_USER'],
      subItems: [
        { to: '/inventory/style', label: 'STYLE NUMBER', groups: ['WEB_SHOW_USER'] },
        { to: '/inventory/barcode', label: 'BARCODE', groups: ['WEB_SHOW_USER'] }
      ]
    },
    */
    { to: '/customer', label: 'CUSTOMER', icon: 'mdi-account-search-outline', groups: ['WEB_SHOW_USER'] },
    { to: '/catalog', label: 'CATALOG', icon: 'mdi-view-gallery-outline ', groups: ['WEB_SHOW_USER', 'WEB_USER'] },
    { to: '/category', label: 'CATEGORY', icon: 'mdi-grid-large', groups: ['WEB_SHOW_USER', 'WEB_USER'] }
  ])

  // computed
  const flatMenus = computed(() => {
    const flatten = []

    for (const item of nav.value) {
      flatten.push({ to: item.to, groups: item.groups })

      addSubMenus(flatten, item)
    }

    return flatten
  })

  const addSubMenus = (flatten, item) => {
    const subItems = getSubMenus(item)
    if (subItems.length === 0) return

    for (const subItem of subItems) {
      flatten.push({ to: subItem.to, groups: subItem.groups })

      addSubMenus(flatten, subItem)
    }
  }

  const getSubMenus = (item) => {
    if (!!item.subItems && item.subItems.length > 0) {
      return item.subItems
    }

    return []
  }

  const getParentMenus = (toPath) => {
    const parentMenus = []
    const parentPaths = []

    const paths = toPath.split('/').filter((path) => path !== '')

    while (paths.length > 1) {
      paths.pop()
      parentPaths.push(`/${paths.join('/')}`)
    }

    for (const parentPath of parentPaths) {
      const pathFind = flatMenus.value.find((m) => m.to === parentPath)
      if (pathFind) {
        parentMenus.push({ to: pathFind.to, groups: pathFind.groups })
      }
    }

    return parentMenus
  }

  const hasAccessToMenu = (toPath, userData) => {
    const pathFind = flatMenus.value.find((m) => m.to === toPath)
    if (pathFind) {
      if (pathFind.groups && !pathFind.groups.includes(userData.userGroup)) {
        return false
      }
    }

    const parentMenus = getParentMenus(toPath)
    for (const parentMenu of parentMenus) {
      if (parentMenu.groups && !parentMenu.groups.includes(userData.userGroup)) {
        return false
      }
    }

    return true
  }

  return { isRailOpen, nav, hasAccessToMenu }
})
